// react imports
import React, { useState } from "react";

// package imports
import { Row, Col, Form, Button } from "react-bootstrap";
import { observer } from "mobx-react";

// project imports
import { BottomsheetDropdown, ChangeProductSection, AdditionalRiderBenifitsCard, DatepickerModal } from "components";
import DeathCoverGraphSlider from "../../death-cover-graph-slider/DeathCoverGraphSlider";
import fetchIncomeLabelBasedOnNeed from "utils/fetchIncomeLabelBasedOnNeed";
import UiButton from "components/ui/button/Button";
import utils from "./utils";
import DeathBenefitAmount from "utils/optimization/deathBenefitAmount";
import CompareProductModal from "../../../../../components/ui/compare-products-modal/CompareProductsModal"

// CSS imports
import "../../optimization-card/family-collapse-view.css";
import moment from "moment";
import OptimizationStore from "modules/optimization/store/OptimizationStore";
import ComapreQuotesTable from "components/ui/compare-quotes-table/ComapreQuotesTable";
import StorageKeys from "constants/StorageKeys";
import { NUMBER_REGEX } from "constants/Constants";
import IsExistingCustomerModalForFDP from "./component/IsExistingCustomerModalForFDP";

const FlexiDreamPlan = ({ form, data }) => {
  let productData = data?.data?.BI.find((item) => item.risk === data?.data?.risk);
  let coverLabelBaseOnNeed = fetchIncomeLabelBasedOnNeed(data.cardKey)

  const handleFunction = (value) => {
    form.$("is-existing-customer")?.extra?.toggleIsExistingCustomerModal(form, false)
    if (value) {
      form.$("is-existing-customer")?.set("value", { label: 'Yes', id: 1 })
    }
  }

  return (
    <div className=''>
      <Row className="align-items-center mt-4">
        <Col md={12} className='mt-3 mt-md-0'>
          <ChangeProductSection
            productName={productData.product_name}
            cardName={coverLabelBaseOnNeed}
            changeProductList={data?.data?.changeProductList || []}
            productData={data}
            form={form}
          />

        </Col>
        {/* <Col md={6} className="mb-4 mb-md-0">
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("payment-frequency").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("payment-frequency").label}
            menuList={form.$("payment-frequency").extra.optionList}
            value={form.$("payment-frequency").value}
            onSelect={form.$("payment-frequency").onChange}
          />
        </Col> */}
      </Row>

      <Row>
        <Col md={12}>
          <ComapreQuotesTable
            form={form}
            ptList={form.$("policy-term").extra.optionList}
            pptList={form.$("premium-term").extra.optionList}
            ptValueId={form.$("policy-term").value}
            ptName={"policy-term"}
            pptName={"premium-term"}
            productData={data}
            cardKey={data.cardKey}
          />
        </Col>
      </Row>

      <Col xs={12} className='mt-2 mt-md-0'>
        <DeathCoverGraphSlider
          productData={data?.data}
          saLabel='Income'
          productTitle={productData.product_name}
          openChangeReasonModal={() => { }}
          onIncomeChange={form.$("income").onChange}
          onPremiumChange={form.$("premium").onChange}
          dataChange={() => { }}
          hideOverLay={() => { }}
          productID={productData.product_id}
          cardKey={data.cardKey}
          income_value={form.$("income").value}
          premium_value={form.$("premium").value}
          showOverlay={false}
          onClick={() => form.$("premium").extra.calculatePremium(form, form.$("premium").value, data)}
          data={""}
          isIncomeFieldDisable={false}
          isPremiumDisable={false}
          premiumFreq={form.$("payment-frequency").value.label}
          onIncomeBlur={() => { form.$("income").extra.calculateIncome(form, data); }}
          formRef={form}
        />
      </Col>

      <Row className='mt-3 ml-0'>
        <p className='graph-label mb-2 font-size-12 font-size-md-14 font-weight-bold'>{"Sum Assured on Death (at inception of the policy):"}</p>
        <p className='graph-label pl-1 font-size-12 font-size-md-14 font-weight-bold'>{DeathBenefitAmount(productData)}</p>
      </Row>

      <Row className='mt-3'>
        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("policy-term").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("policy-term").label}
            menuList={form.$("policy-term").extra.optionList}
            value={form.$("policy-term").value}
            onSelect={form.$("policy-term").onChange}
            disabled={form.$("policy-term").disabled}
          />
        </Col>

        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("premium-term").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("premium-term").label}
            menuList={form.$("premium-term").extra.optionList}
            value={form.$("premium-term").value}
            onSelect={form.$("premium-term").onChange}
          />
        </Col>
        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("payment-frequency").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("payment-frequency").label}
            menuList={form.$("payment-frequency").extra.optionList}
            value={form.$("payment-frequency").value}
            onSelect={form.$("payment-frequency").onChange}
            disabled={form.$("payment-frequency").disabled}
          />
        </Col>

        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("auto-renewal-booster").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("auto-renewal-booster").label}
            menuList={form.$("auto-renewal-booster").extra.optionList}
            value={form.$("auto-renewal-booster").value}
            onSelect={form.$("auto-renewal-booster").onChange}
            disabled={form.$("auto-renewal-booster").disabled}
          />
        </Col>
        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("is-existing-customer").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("is-existing-customer").label}
            menuList={form.$("is-existing-customer").extra.optionList}
            value={form.$("is-existing-customer").value}
            onSelect={(value) => {
              form.$("is-existing-customer").onChange(value)
              if (Number(value.id) === 1) {
                form.$("is-existing-customer")?.extra?.toggleIsExistingCustomerModal(form, true)
                form.$("is-existing-customer").set("value", { label: 'No', id: 2 })
              }
            }}
            disabled={Number(form?.$("is-existing-customer")?.value?.id) === 1 ? true : false}
          />
        </Col>

        {/* <Col md={4} className="col-12 mb-3">
          <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("total-survival-benefit").label}
          </div>
          <Form.Group className='mb-0 flex-grow-1'>
            <Form.Control
              // className='font-size-lg-12 font-size-14 font-weight-light text-description-text-color h-100 border-gray rounded-0'
              className="font-size-12 font-weight-light text-black mt-2 product-form-field"
              placeholder=''
              disabled={form.$("total-survival-benefit").disabled}
              value={form.$("total-survival-benefit").value}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || (NUMBER_REGEX.test(value))) {
                  form.$("total-survival-benefit").onChange(e);
                }
              }
              }
              style={form.$("total-survival-benefit").error ? { border: "1px solid red" } : null}
            />
            {form.$("total-survival-benefit").error != null ? <p className='font-size-11 font-weight-light text-danger'>{formController.$("total-survival-benefit").error}</p> : null}
          </Form.Group>
        </Col> */}

        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("proposition").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("proposition").label}
            menuList={form.$("proposition").extra.optionList}
            value={form.$("proposition").value}
            onSelect={form.$("proposition").onChange}
            disabled={form.$("proposition").disabled}
          />
        </Col>


        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("accrual-period").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("accrual-period").label}
            menuList={form.$("accrual-period").extra.optionList}
            value={form.$("accrual-period").value}
            onSelect={form.$("accrual-period").onChange}
            disabled={form.$("accrual-period").disabled}
          />
        </Col>

        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("ROP").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("ROP").label}
            menuList={form.$("ROP").extra.optionList}
            value={form.$("ROP").value}
            onSelect={form.$("ROP").onChange}
            disabled={form.$("ROP").disabled}
          />
        </Col>

        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("plan-option").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("plan-option").label}
            menuList={form.$("plan-option").extra.optionList}
            value={form.$("plan-option").value}
            onSelect={form.$("plan-option").onChange}
            disabled={form.$("plan-option").disabled}
          />
        </Col>
        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("two-gether-option").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("two-gether-option").label}
            menuList={form.$("two-gether-option").extra.optionList}
            value={form.$("two-gether-option").value}
            onSelect={form.$("two-gether-option").onChange}
            disabled={form.$("two-gether-option").disabled}
          />
        </Col>
        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("death-benefit-option").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("death-benefit-option").label}
            menuList={form.$("death-benefit-option").extra.optionList}
            value={form.$("death-benefit-option").value}
            onSelect={form.$("death-benefit-option").onChange}
            disabled={form.$("death-benefit-option").disabled}
          />
        </Col>
        {/* <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("life-cover").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("life-cover").label}
            menuList={form.$("life-cover").extra.optionList}
            value={form.$("life-cover").value}
            onSelect={form.$("life-cover").onChange}
            disabled={form.$("life-cover").disabled}
          />
        </Col> */}

        {form.$("second-life-assured-first-name").extra.hide &&

          <Col xs={12} md={4} className='mb-3' >

            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("second-life-assured-first-name").label}
            </div>

            <Form.Control
              className="font-size-12 font-weight-light text-black product-form-field"
              placeholder={form.$("second-life-assured-first-name").label}
              value={form.$("second-life-assured-first-name").value}
              onChange={form.$('second-life-assured-first-name').onChange}
              onBlur={() => form.$('second-life-assured-first-name').extra.onSecondLANameChange(form, data)}
              disabled={form.$("second-life-assured-first-name").disabled}
            />

          </Col>
        }

        {form.$("second-life-assured-last-name").extra.hide &&

          <Col xs={12} md={4} className='mb-3' >

            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("second-life-assured-last-name").label}
            </div>

            <Form.Control
              className="font-size-12 font-weight-light text-black product-form-field"
              placeholder={form.$("second-life-assured-last-name").label}
              value={form.$("second-life-assured-last-name").value}
              onChange={form.$('second-life-assured-last-name').onChange}
              onBlur={() => form.$('second-life-assured-last-name').extra.onSecondLANameChange(form, data)}
              disabled={form.$("second-life-assured-last-name").disabled}
            />

          </Col>
        }

        {form.$("second-life-assured-gender").extra.hide &&
          <Col xs={12} md={4} className='mb-3'>
            <p className='mb-2 font-size-12 font-weight-light '>{form.$("second-life-assured-gender").label}</p>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("second-life-assured-gender").label}
              menuList={form.$("second-life-assured-gender").extra.optionList}
              value={form.$("second-life-assured-gender").value}
              onSelect={form.$("second-life-assured-gender").onChange}
              disabled={form.$("second-life-assured-gender").disabled}
            />
          </Col>
        }

        {form.$("second-life-assured-dob").extra.hide &&
          <Col xs={12} md={4} className='mb-3'>
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("second-life-assured-dob").label}
            </div>
            <DatepickerModal
              date={form.$("second-life-assured-dob").value}
              value={form.$("second-life-assured-dob").value}
              textStyle='font-size-12 font-weight-light text-black text-nowrap overflow-hidden txt-overflow'
              onChange={(value) => form.$("second-life-assured-dob").extra.onSecondLADobChange(value, form, data)}
              // disabled={form.$('marital-status').value.id == 9}
              disabled={form.$("second-life-assured-dob").disabled}
              minDate={""}
              maxDate={moment().subtract(45, "years").toString()}
            />
          </Col>
        }
        {!form.$("accrual-of-survival-benefit").extra.hide &&
          <Col xs={12} md={4} className='mb-3'>
            <p className='mb-2 font-size-12 font-weight-light '>{form.$("accrual-of-survival-benefit").label}</p>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("accrual-of-survival-benefit").label}
              menuList={form.$("accrual-of-survival-benefit").extra.optionList}
              value={form.$("accrual-of-survival-benefit").value}
              onSelect={form.$("accrual-of-survival-benefit").onChange}
              disabled={form.$("accrual-of-survival-benefit").disabled}
            />
          </Col>
        }
        {!form.$("asb-start-age-(1st-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>

            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-start-age-(1st-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-start-age-(1st-opt-in)").label}
              menuList={form.$("asb-start-age-(1st-opt-in)").extra.optionList}
              value={form.$("asb-start-age-(1st-opt-in)").value}
              onSelect={form.$("asb-start-age-(1st-opt-in)").onChange}
              disabled={form.$("asb-start-age-(1st-opt-in)").disabled}
            />

          </Col>
        }

        {!form.$("asb-end-age-(1st-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>

            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-end-age-(1st-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-end-age-(1st-opt-in)").label}
              menuList={form.$("asb-end-age-(1st-opt-in)").extra.optionList}
              value={form.$("asb-end-age-(1st-opt-in)").value}
              onSelect={form.$("asb-end-age-(1st-opt-in)").onChange}
              disabled={form.$("asb-end-age-(1st-opt-in)").disabled}
            />

          </Col>
        }

        {!form.$("withdrawal-parcentage-1").extra.hide &&
          <Col md={4} className='col-12 mb-3'>

            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("withdrawal-parcentage-1").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("withdrawal-parcentage-1").label}
              menuList={form.$("withdrawal-parcentage-1").extra.optionList}
              value={form.$("withdrawal-parcentage-1").value}
              onSelect={form.$("withdrawal-parcentage-1").onChange}
              disabled={form.$("withdrawal-parcentage-1").disabled}
            />

          </Col>
        }
        {/* 
        {!form.$("accrual-of-survival-benefits-year-2").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
           
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("accrual-of-survival-benefits-year-2").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("accrual-of-survival-benefits-year-2").label}
              menuList={form.$("accrual-of-survival-benefits-year-2").extra.optionList}
              value={form.$("accrual-of-survival-benefits-year-2").value}
              onSelect={form.$("accrual-of-survival-benefits-year-2").onChange}
              disabled={form.$("accrual-of-survival-benefits-year-2").disabled}
            />
         
          </Col>
        }

        {!form.$("asb-start-age-(2nd-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
           
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-start-age-(2nd-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-start-age-(2nd-opt-in)").label}
              menuList={form.$("asb-start-age-(2nd-opt-in)").extra.optionList}
              value={form.$("asb-start-age-(2nd-opt-in)").value}
              onSelect={form.$("asb-start-age-(2nd-opt-in)").onChange}
              disabled={form.$("asb-start-age-(2nd-opt-in)").disabled}
            />
         
          </Col>
        }

        {!form.$("asb-end-age-(2nd-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
           
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-end-age-(2nd-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-end-age-(2nd-opt-in)").label}
              menuList={form.$("asb-end-age-(2nd-opt-in)").extra.optionList}
              value={form.$("asb-end-age-(2nd-opt-in)").value}
              onSelect={form.$("asb-end-age-(2nd-opt-in)").onChange}
              disabled={form.$("asb-end-age-(2nd-opt-in)").disabled}
            />
         
          </Col>

        }

        {!form.$("withdrawal-parcentage-2").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
           
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("withdrawal-parcentage-2").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("withdrawal-parcentage-2").label}
              menuList={form.$("withdrawal-parcentage-2").extra.optionList}
              value={form.$("withdrawal-parcentage-2").value}
              onSelect={form.$("withdrawal-parcentage-2").onChange}
              disabled={form.$("withdrawal-parcentage-2").disabled}
            />
         
          </Col>
        }

        {!form.$("accrual-of-survival-benefits-year-3").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
           
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("accrual-of-survival-benefits-year-3").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("accrual-of-survival-benefits-year-3").label}
              menuList={form.$("accrual-of-survival-benefits-year-3").extra.optionList}
              value={form.$("accrual-of-survival-benefits-year-3").value}
              onSelect={form.$("accrual-of-survival-benefits-year-3").onChange}
              disabled={form.$("accrual-of-survival-benefits-year-3").disabled}
            />
         
          </Col>
        }

        {!form.$("asb-start-age-(3rd-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
           
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-start-age-(3rd-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-start-age-(3rd-opt-in)").label}
              menuList={form.$("asb-start-age-(3rd-opt-in)").extra.optionList}
              value={form.$("asb-start-age-(3rd-opt-in)").value}
              onSelect={form.$("asb-start-age-(3rd-opt-in)").onChange}
              disabled={form.$("asb-start-age-(3rd-opt-in)").disabled}
            />
         
          </Col>
        }

        {!form.$("asb-end-age-(3rd-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
           
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-end-age-(3rd-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-end-age-(3rd-opt-in)").label}
              menuList={form.$("asb-end-age-(3rd-opt-in)").extra.optionList}
              value={form.$("asb-end-age-(3rd-opt-in)").value}
              onSelect={form.$("asb-end-age-(3rd-opt-in)").onChange}
              disabled={form.$("asb-end-age-(3rd-opt-in)").disabled}
            />
         
          </Col>
        }

        {!form.$("withdrawal-parcentage-3").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("withdrawal-parcentage-3").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("withdrawal-parcentage-3").label}
              menuList={form.$("withdrawal-parcentage-3").extra.optionList}
              value={form.$("withdrawal-parcentage-3").value}
              onSelect={form.$("withdrawal-parcentage-3").onChange}
              disabled={form.$("withdrawal-parcentage-3").disabled}
            />
          </Col>
        } */}
        {/* 
        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("maturity-benefit-payment-mode").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("maturity-benefit-payment-mode").label}
            menuList={form.$("maturity-benefit-payment-mode").extra.optionList}
            value={form.$("maturity-benefit-payment-mode").value}
            onSelect={form.$("maturity-benefit-payment-mode").onChange}
            disabled={form.$("maturity-benefit-payment-mode").disabled}
          />
        </Col>
        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("maturity-benefit-lumpsum-percentage").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("maturity-benefit-lumpsum-percentage").label}
            menuList={form.$("maturity-benefit-lumpsum-percentage").extra.optionList}
            value={form.$("maturity-benefit-lumpsum-percentage").value}
            onSelect={form.$("maturity-benefit-lumpsum-percentage").onChange}
            disabled={form.$("maturity-benefit-lumpsum-percentage").disabled}
          />
        </Col>
        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("number-of-months-maturity-benefit-paid").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("number-of-months-maturity-benefit-paid").label}
            menuList={form.$("number-of-months-maturity-benefit-paid").extra.optionList}
            value={form.$("number-of-months-maturity-benefit-paid").value}
            onSelect={form.$("number-of-months-maturity-benefit-paid").onChange}
            disabled={form.$("number-of-months-maturity-benefit-paid").disabled}
          />
        </Col>

        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("death-benefit-payment-mode").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("death-benefit-payment-mode").label}
            menuList={form.$("death-benefit-payment-mode").extra.optionList}
            value={form.$("death-benefit-payment-mode").value}
            onSelect={form.$("death-benefit-payment-mode").onChange}
            disabled={form.$("death-benefit-payment-mode").disabled}
          />
        </Col>
        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("death-benefit-lumpsum-percentage").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("death-benefit-lumpsum-percentage").label}
            menuList={form.$("death-benefit-lumpsum-percentage").extra.optionList}
            value={form.$("death-benefit-lumpsum-percentage").value}
            onSelect={form.$("death-benefit-lumpsum-percentage").onChange}
            disabled={form.$("death-benefit-lumpsum-percentage").disabled}
          />
        </Col>
        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("number-of-months-death-benefit-paid").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("number-of-months-death-benefit-paid").label}
            menuList={form.$("number-of-months-death-benefit-paid").extra.optionList}
            value={form.$("number-of-months-death-benefit-paid").value}
            onSelect={form.$("number-of-months-death-benefit-paid").onChange}
            disabled={form.$("number-of-months-death-benefit-paid").disabled}
          />
        </Col> */}

        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("income-frequency-mode").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("income-frequency-mode").label}
            menuList={form.$("income-frequency-mode").extra.optionList}
            value={form.$("income-frequency-mode").value}
            onSelect={form.$("income-frequency-mode").onChange}
            disabled={form.$("income-frequency-mode").disabled}
          />
        </Col>

        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("survival-benefit-advance").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("survival-benefit-advance").label}
            menuList={form.$("survival-benefit-advance").extra.optionList}
            value={form.$("survival-benefit-advance").value}
            onSelect={form.$("survival-benefit-advance").onChange}
            disabled={form.$("survival-benefit-advance").disabled}
          />
        </Col>

      </Row>



      <Row className="mt-4">
        <Col md={6} className="col-12 my-4 ">
          <AdditionalRiderBenifitsCard
            data={data}
            form={form}
            showCriticalIllness={!form.$("CriticalIllnessRider").extra.hide}
            showIncomeBenefit={!form.$("IncomeBenefitRider").extra.hide}
            showHospitalityCashBenefit={false}
            showWOP={!form.$("WaiverOfPremiumRider").extra.hide}
            showPWB={!form.$("PayorWaiverBenefitRider").extra.hide}
            showADB={!form.$("ADB").extra.hide}
            showATPD={!form.$("ATPDRider").extra.hide}
          />
        </Col>
      </Row>
      {form.$("is-existing-customer").extra.showExistingCustomerModal &&
        <IsExistingCustomerModalForFDP
          formRef={form}
          productData={productData}
          show={form.$("is-existing-customer").extra.showExistingCustomerModal}
          onHide={handleFunction}
        />
      }
    </div>
  );
};

export default observer(FlexiDreamPlan);


